// TODO, remove eslint-disable

/* eslint-disable max-classes-per-file */
import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

export class Provider extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  static childContextTypes = {
    amp: PropTypes.bool.isRequired,
  };

  getChildContext() {
    return { amp: true };
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}

export default (AmpComponent) => (OriginalComponent) => {
  if (!AmpComponent) {
    /*
     OriginalComponent.prototype.renderNormal = OriginalComponent.prototype.render;
     OriginalComponent.prototype.render = function () {
     const { amp } = this.props;

     if (amp && this.renderAmp) {
     return this.renderAmp();
     }

     return this.renderNormal();
     };
     */
    throw new Error('If you need to leverage renderAmp(), please implement line 24');
  }

  // eslint-disable-next-line react/prefer-stateless-function
  return class extends React.Component {
    static contextTypes = {
      amp: PropTypes.bool,
    };

    static get name() { // hopefully get rid of some instances of `_class2`
      return `AmpWrapper(${OriginalComponent.name})`;
    }

    render() {
      const { props, context } = this;
      if (context.amp) {
        return <AmpComponent {...props} />;
      }

      return <OriginalComponent {...props} />;
    }
  };
};

/* eslint-enable max-classes-per-file */
